"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lock = _interopRequireDefault(require("cccisd-icons/lock4"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Tab = function Tab(_ref) {
  var currTab = _ref.currTab,
    mediatorProps = _ref.mediatorProps,
    onClickTab = _ref.onClickTab,
    tabKey = _ref.tabKey;
  var locked = false;
  if (!mediatorProps[tabKey]) {
    tabKey = tabKey.replace(/_locked$/, '');
    if (!mediatorProps[tabKey]) {
      return null;
    }
    locked = true;
  }
  if (!mediatorProps[tabKey].toggle && !mediatorProps[tabKey].isExternalRegistration) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'btn-group ' + _style["default"].tab
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-default ".concat(currTab === tabKey ? 'active' : ''),
    onClick: function onClick() {
      if (!locked) {
        onClickTab(tabKey);
      }
    },
    disabled: locked
  }, mediatorProps[tabKey].tabName, locked ? /*#__PURE__*/_react["default"].createElement("span", null, "\xA0\xA0", /*#__PURE__*/_react["default"].createElement(_lock["default"], null)) : null));
};
var _default = Tab;
exports["default"] = _default;